import { render } from "./DataImportIcon.vue?vue&type=template&id=976fcb7c&ts=true"
import script from "./DataImportIcon.vue?vue&type=script&lang=ts"
export * from "./DataImportIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__